<template>
  <TheToast />
  <div class="c-app flex-row align-items-center bg-primary">
    <CContainer class="col-md-7">
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <router-view v-slot="{ Component, route }">
              <transition name="fade" mode="out-in">
                <component :is="Component" :key="$route.path"/>
              </transition>
            </router-view>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <LoginRight />
  </div>
</template>

<script>
import LoginRight from "@/components/LoginRight";
import TheToast from "@/containers/TheToast";

export default {
  name: "AccountContainer",
  components: { LoginRight, TheToast },
};
</script>
